export const PERMISSION_STORAGE_KEY = "permissions";

export const PERMISSION_MODULES = Object.freeze({
  MANAGE_DATA: "Manage Data",
  VISUALIZATION: "Visualization",
  PROCESS: "Process",
  LIMITS: "Limits",
  BATCHES: "Batches",
  REPORT: "Report",
  DASHBOARD: "Dashboard",
  CONFIGURATION: "Configuration",
  GENEALOGY: "Genelogy",
  USER_ACCESS_MANAGEMENT: "User Access Management",
  TASK_STATUS: "Task Status",
  AUDIT_TRAIL: "Audit Trail",
  SEARCH_AND_INVESTIGATE: "Search and Investigate",
  DATA_PREVIEW: "Data Preview",
});

export const MANAGE_DATA_MODULE = PERMISSION_MODULES.MANAGE_DATA;

export const SRM_MODULES = Object.freeze([
  PERMISSION_MODULES.VISUALIZATION,
  PERMISSION_MODULES.PROCESS,
  PERMISSION_MODULES.LIMITS,
  PERMISSION_MODULES.BATCHES,
  PERMISSION_MODULES.REPORT,
  PERMISSION_MODULES.DASHBOARD,
]);

export const MANAGE_DATA_PERMISSIONS = Object.freeze({
  VIEW_BATCH_LIST: "View Batch List",
  DOWNLOAD_TEMPLATE: "Download Template",
  UPLOAD_DATA: "Upload Data",
  VIEW_BATCH_DATA: "View Batch Data",
  EDIT_BATCH_VALUES: "Edit Batch Values",
  COPY_BATCH: "Copy Batch to Latest Unit Operation Template",
  AUDIT_TRAIL: "Audit Trail",
  VIEW_COPIED_BATCHES: "View Copied Batches",
  APPROVE_BATCHES: "Approve Batch / Bulk Approve Batches",
});

export const VISUALIZATION_PERMISSIONS = Object.freeze({
  VIEW_CHART_LIST: "View Chart List",
  OPEN_CHART: "Open Chart",
  EDIT_CHART: "Edit Chart",
  DELETE_CHART: "Delete Chart",
  CREATE_NEW_CHART: "Create New Chart",
  AUDIT_TRAIL: "Audit Trail for Visualization",
});

export const PROCESS_PERMISSIONS = Object.freeze({
  VIEW_PARAMETER_LIST: "View Parameter List",
  EDIT_DESCRIPTION_AND_NOTES: "Edit Description and Notes",
});

export const LIMITS_PERMISSIONS = Object.freeze({
  VIEW_LIMITS_LIST: "View Limits List",
  ADD_LIMIT: "Add Limit",
  ADD_SPECIFICATION_LIMIT_NAME: "Add Specification Limit Name",
  AUDIT_TRAIL: "Audit Trail",
  DELETE_LIMIT: "Delete Limit",
  EDIT_LIMIT: "Edit Limit",
});

export const BATCHES_PERMISSIONS = Object.freeze({
  VIEW_BATCH_LIST: "View Batch List",
  DOWNLOAD_BATCHES: "Download and Download All  Batches",
  DOWNLOAD_PARTIAL_DATA: "Download Partial Data",
  PARTIAL_DATA_TAB: "Partial Data Tab",
  VIEW_META_DATA: "View Meta/Data",
});

export const REPORT_PERMISSIONS = Object.freeze({
  VIEW_REPORT_LIST: "View Report List",
  CREATE_NEW_REPORT: "Create New Report",
  DOWNLOAD_REPORT: "Download Report",
  EDIT_DRAFT_REPORT: "Edit Draft Report",
});

export const DASHBOARD_PERMISSIONS = Object.freeze({
  ACCESS_DASHBOARD: "Access Dashboard",
  PARAMETER_CHARTS: "Parameter Charts",
  PRODUCT_VARIANT: "Product Variant",
});

export const CONFIGURATION_PERMISSIONS = Object.freeze({
  ADD_PRODUCT: "Add Product",
  ADD_MANUFACTURING_SITE: "Add Manufacturing Site",
  ADD_PARAMETER: "Add Parameter",
  ADD_PARAMETER_PHASE: "Add Parameter Phase",
  ADD_PARAMETER_TABLE: "Add Parameter Table",
  ADD_UNIT_OPERATION: "Add Unit Operation",
  AUDIT_TRAIL: "Configuration Audit Trail",
  UPDATE_MANUFACTURING_SITE: "Update Manufacturing Site",
  UPDATE_PARAMETER: "Update Parameter",
  UPDATE_PRODUCT: "Update Product",
  UPDATE_UNIT_OPERATION: "Update Unit Operation",
  VIEW_PRODUCT_LIST: "View Product List",
  APPROVE_PRODUCT: "Approve Product",
  VIEW_MANUFACTURING_SITE_LIST: "View Manufacturing Site List",
  APPROVE_MANUFACTURING_SITE: "Approve Manufacturing Site",
  VIEW_UNIT_OPERATION_LIST: "View Unit Operation List",
  APPROVE_UNIT_OPERATION: "Approve Unit Operation",
  VIEW_PARAMETER_LIST: "View Parameter List",
  DELETE_PARAMETER: "Delete Parameter",
  RESTORE_PARAMETER: "Restore Parameter",
  APPROVE_PARAMETER: "Approve Parameter",
  REORDER_PARAMETERS: "Reorder Parameters",
  DELETE_PARAMETER_PHASE: "Delete Parameter Phase",
  DELETE_PARAMETER_TABLE: "Delete Parameter Table",
});

export const GENEALOGY_PERMISSIONS = Object.freeze({
  VIEW_REPORT_LIST: "View Report List",
  CREATE_NEW_REPORT: "Create New Report",
  DOWNLOAD_EXCEL: "Download Excel",
  EDIT_DRAFT_REPORT: "Edit Draft Report",
  VIEW_SAVED_REPORT: "View Saved Report",
});

export const USER_ACCESS_MANAGEMENT_PERMISSIONS = Object.freeze({
  VIEW_USER_LIST: "View User List",
  EDIT_USER: "Edit User",
  UPDATE_USER_STATUS: "Update User Status",
  EXPORT_USERS: "Export Users",
  VIEW_ACCESS_GROUP_LIST: "View Access Group List",
  CREATE_ACCESS_GROUP: "Create Access Group",
  EDIT_ACCESS_GROUP: "Edit Access Group",
  UPDATE_ACCESS_GROUP_STATUS: "Update Access Group Status",
  UPDATE_ACCESS_GROUP_PERMISSIONS: "Update Access Group Permissions",
  EXPORT_ACCESS_GROUPS: "Export Access Groups",
  VIEW_AUDIT_TRAIL: "View User Management Audit Trail",
  EXPORT_AUDIT_TRAIL: "Export User Management Audit Trail",
});

export const FULL_ACCESS_PERMISSIONS = Object.freeze({
  FULL_ACCESS: "Full Access",
});

export const MODULE_PERMISSIONS = Object.freeze({
  [PERMISSION_MODULES.MANAGE_DATA]: MANAGE_DATA_PERMISSIONS,
  [PERMISSION_MODULES.VISUALIZATION]: VISUALIZATION_PERMISSIONS,
  [PERMISSION_MODULES.PROCESS]: PROCESS_PERMISSIONS,
  [PERMISSION_MODULES.LIMITS]: LIMITS_PERMISSIONS,
  [PERMISSION_MODULES.BATCHES]: BATCHES_PERMISSIONS,
  [PERMISSION_MODULES.REPORT]: REPORT_PERMISSIONS,
  [PERMISSION_MODULES.DASHBOARD]: DASHBOARD_PERMISSIONS,
  [PERMISSION_MODULES.CONFIGURATION]: CONFIGURATION_PERMISSIONS,
  [PERMISSION_MODULES.GENEALOGY]: GENEALOGY_PERMISSIONS,
  [PERMISSION_MODULES.USER_ACCESS_MANAGEMENT]:
    USER_ACCESS_MANAGEMENT_PERMISSIONS,
  [PERMISSION_MODULES.TASK_STATUS]: FULL_ACCESS_PERMISSIONS,
  [PERMISSION_MODULES.AUDIT_TRAIL]: FULL_ACCESS_PERMISSIONS,
  [PERMISSION_MODULES.SEARCH_AND_INVESTIGATE]: FULL_ACCESS_PERMISSIONS,
  [PERMISSION_MODULES.DATA_PREVIEW]: FULL_ACCESS_PERMISSIONS,
});
